import Head from 'next/head';
import React from 'react';

const DESCRIPTION = 'description';
const OG_DESCRIPTION = 'og:description';
const TWITTER_DESCRIPTION = 'twitter:description';

type DescriptionProps = {
  description?: string;
};

/**
 * Description Head Component to set the description meta tags.
 * @param {string} description
 */
function Description({ description }: DescriptionProps) {
  if (!description) return null;

  return (
    <Head>
      <meta name={DESCRIPTION} key={DESCRIPTION} content={description} />
      <meta property={OG_DESCRIPTION} key={OG_DESCRIPTION} content={description} />
      <meta property={TWITTER_DESCRIPTION} key={TWITTER_DESCRIPTION} content={description} />
    </Head>
  );
}

export default React.memo(Description);
